var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white", attrs: { id: "postlive" } },
    [
      _c(
        "b-container",
        { staticClass: "py-md-5" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "py-4",
                  class: _vm.postliveQa() ? "mw-lg-50" : null,
                  attrs: { cols: "12", lg: "auto" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "p-5 p-md-0 rounded",
                      class: [
                        _vm.asset.text_color
                          ? "text-" + _vm.asset.text_color
                          : "text-dark",
                      ],
                    },
                    [
                      _c("h3", {
                        domProps: {
                          innerHTML: _vm._s(_vm.makeBr(_vm.asset.title)),
                        },
                      }),
                      _vm.asset.description
                        ? _c("p", {
                            staticClass: "lead m-0 pt-4",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.makeBr(_vm.asset.description)
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm.asset.description
                        ? _c("div", { staticClass: "line pt-3" })
                        : _vm._e(),
                      _vm.asset.postlive
                        ? _c("p", {
                            staticClass: "lead m-0 pt-3",
                            domProps: {
                              innerHTML: _vm._s(_vm.makeBr(_vm.asset.postlive)),
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm.postliveQa()
                ? _c(
                    "b-col",
                    {
                      staticClass: "ml-auto mw-lg-50",
                      attrs: { cols: "12", lg: "auto" },
                    },
                    [_c("Ask")],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }